import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from '@services/utility.service';
import { DeviceData } from '@/Interface/wapda';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-wapda-tab',
  templateUrl: './wapda-tab.component.html',
  styleUrls: ['./wapda-tab.component.scss']
})
export class WapdaTabComponent implements OnInit {
  type17Devices: DeviceData[] = [];
  type47Devices: DeviceData[] = [];
  isDownloading: boolean = false;
  selectedDate: Date = null;
  datePickerConfig: Partial<BsDaterangepickerConfig> = {
    showWeekNumbers: false,
    dateInputFormat: 'DD/MM/YYYY',
    maxDate: new Date(),
  };
  modalRef: NgbModalRef | null = null;
  @Input()
  set reloadWapda(value: boolean) {
    if (value) {
      this.fetchWapdaData();
    }
  }
  // NE=50922688
  stationCode: string = ''
  currentTab = 'table'
  isLoadingTable: boolean = false;
  wapdaList: DeviceData[] = []
  readonly KEY_LABEL_MAP: Record<string, string> = {
    // Grid Meter
    "ab_u": "Line Voltage (A-B)",
    "bc_u": "Line Voltage (B-C)",
    "ca_u": "Line Voltage (C-A)",
    "a_u": "Phase A Voltage",
    "b_u": "Phase B Voltage",
    "c_u": "Phase C Voltage",
    "a_i": "Phase A Current",
    "b_i": "Phase B Current",
    "c_i": "Phase C Current",
    "active_power": "Active Power",
    "reactive_power": "Reactive Power",
    "power_factor": "Power Factor",
    "active_cap": "Positive Active Energy",
    "reverse_active_cap": "Negative Active Energy",
    "active_power_a": "Active Power (A)",
    "active_power_b": "Active Power (B)",
    "active_power_c": "Active Power (C)",
    "grid_frequency": "Grid Frequency",

    // Additional frontend-only keys
    "meter_status": "Meter Status",
    "meter_u": "Grid Voltage",
    "meter_i": "Grid Current"
  };

  readonly TYPE_17_HEADERS: string[] = [
    "a_i", "a_u", "b_i", "b_u", "c_i", "c_u",
    "ab_u", "bc_u", "ca_u", "active_cap", "active_power",
    "power_factor", "active_power_a", "active_power_b",
    "active_power_c", "grid_frequency", "reactive_power",
    "reverse_active_cap"
  ];
  readonly TYPE_47_HEADERS: string[] = [
    "a_i", "a_u",       // Include even if missing from data
    "b_i", "b_u",
    "c_i", "c_u",
    "ab_u", "bc_u", "ca_u",
    "meter_i", "meter_u",
    "active_cap", "active_power",
    "power_factor", "active_power_a", "active_power_b", "active_power_c",
    "grid_frequency", "reactive_power", "reverse_active_cap"
  ];
  headersFor17ToDisplay = this.TYPE_17_HEADERS;
  headersFor47ToDisplay = this.TYPE_47_HEADERS;



  constructor(
    private _utilityService: UtilityService,
    private modalService: NgbModal,
    private datePipe: DatePipe,
    private toaster: ToastrService,

  ) {
    this._utilityService.selectedProduct$.subscribe((value) => {
      this.stationCode = value;
    });
  }

  ngOnInit(): void {
    this.fetchWapdaData()
  }
  onTabChange(tab: string) {
    this.currentTab = tab;
    // if (tab.nextId === 'type17Tab' && this.type17Devices.length === 0) {
    //   this.fetchWapdaData();
    // } else if (tab.nextId === 'type47Tab' && this.type47Devices.length === 0) {
    //   this.fetchWapdaData();
    // }
  }

  fetchWapdaData() {
    if (this.stationCode) {
      this.isLoadingTable = true
      this._utilityService.getWapdaData(this.stationCode)
        .subscribe({
          next: (res: any) => {
            if (res && res.status === 200) {
              this.wapdaList = res.data
              this.type17Devices = this.wapdaList.filter(d => d.devTypeId === 17);
              this.type47Devices = this.wapdaList.filter(d => d.devTypeId === 47);
            }
            setTimeout(() => {
              this.isLoadingTable = false;
            }, 500);
          },
          error: () => {
            this.isLoadingTable = false;
          }
        });
    }
  }

  getAllHeaders(): string[] {
    const headers = new Set<string>();
    this.wapdaList.forEach(d => {
      Object.keys(d.dataItemMap).forEach(k => headers.add(k));
    });
    return Array.from(headers);
  }

  getDataForKey(dev: DeviceData, key: string): any {
    return dev.dataItemMap[key] ?? null;
  }

  getHeaders(devices: DeviceData[]): string[] {
    const headers = new Set<string>();
    devices.forEach(d => {
      Object.keys(d.dataItemMap).forEach(k => headers.add(k));
    });
    return Array.from(headers);
  }

  getValue(dev: DeviceData, key: string): any {
    return dev.dataItemMap[key] ?? null;
  }
  getHeaderLabel(key: string): string {
    return this.KEY_LABEL_MAP[key] || key;
  }
  openDownloadPopup(content: any) {
    this.selectedDate = new Date()
    this.modalRef = this.modalService.open(content, { centered: true });
  }
  downloadReport(): void {
    if (this.stationCode && this.selectedDate) {
      const date = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
      this.isDownloading = true;
      this._utilityService
        .downloadWapdaReport(this.stationCode, date)
        .subscribe({
          next: (res: Blob) => {
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `Wapda_Report_${this.stationCode}.xlsx`;
            a.click();

            window.URL.revokeObjectURL(url);
            this.isDownloading = false; // stop loader
          },
          error: () => {
            // this.resetForm();
            this.isDownloading = false; // stop loader on error
            this.toaster.error('Failed to download report. Please try again.');
          }
        });
    }
    else {
      this.toaster.warning('Please select the date before downloading report.');
    }
  }

}
